define('modules/news/news_collection',[
  'backbone',
  'jquery',
  '_',
  './news_item_model',
  'session'
], function (Backbone, $, _, NewsItemModel, session) {
  'use strict';
  var Collection = Backbone.Collection.extend({
    model: NewsItemModel,
    metadata: {},
    params: {
      search: null,
      order_by: 'pinned',
      order: 'DESC'
    },
    parse: function (response) {
      if (response.metadata) {
        this.metadata = _.extend(response.metadata);
        this.params = _.extend(response.metadata);
      }
      return response.data;
    },
    url: function () {
      return session.get('apiUrl') + 'news?' + $.param(this.params || {});
    }
  });

  return new Collection();
});

